var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 68,
    viewBox: "0 0 86 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 62C46.677 62 50.318 61.2758 53.7151 59.8686C57.1123 58.4615 60.1989 56.399 62.799 53.799C65.399 51.1989 67.4615 48.1123 68.8686 44.7151C70.2758 41.318 71 37.677 71 34C71 30.323 70.2758 26.682 68.8686 23.2849C67.4615 19.8877 65.399 16.8011 62.799 14.201C60.1989 11.601 57.1123 9.5385 53.7151 8.13137C50.318 6.72424 46.677 6 43 6C35.5739 6 28.452 8.94999 23.201 14.201C17.95 19.452 15 26.5739 15 34C15 41.4261 17.95 48.548 23.201 53.799C28.452 59.05 35.5739 62 43 62ZM42.2782 45.3244L57.8338 26.6578L53.0551 22.6756L39.6773 38.7258L32.7551 31.8004L28.356 36.1996L37.6893 45.5329L40.0973 47.9409L42.2782 45.3244Z",
    fill: "#56FF50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/Checked.dbdba3913f14819c55e2440397a3090b.svg";
export { ForwardRef as ReactComponent };